import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/language/[locale]/layout.js");
